import type {
  AdOperatorReportIoDeliveryActionFragment,
  AdOperatorReportIoPickupActionFragment,
  AdOperatorReportIoWaypointFragment,
} from './AdOperatorReportIo.hook'

type WaypointAction = AdOperatorReportIoWaypointFragment['actions'][number]

const isPickupAction = (
  action: WaypointAction,
): action is AdOperatorReportIoPickupActionFragment => {
  return action.__typename === 'FccWaypointPickupAction'
}

const isDeliveryAction = (
  action: WaypointAction,
): action is AdOperatorReportIoDeliveryActionFragment => {
  return action.__typename === 'FccWaypointDeliveryAction'
}

export const getTripIdsFromWaypoints = (
  waypoints: AdOperatorReportIoWaypointFragment[] | null,
) => {
  const allTripIds = waypoints
    ?.flatMap(waypoint => waypoint.actions)
    .filter(action => isPickupAction(action) || isDeliveryAction(action))
    .flatMap(action => action.trip?.id)
    .filter(id => id !== undefined)
  return allTripIds && [...new Set(allTripIds)]
}
